<template>
  <svg
    width="11"
    height="10"
    viewBox="0 0 11 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.47619 9L5.47619 1M1 5H9.95238"
      stroke="url(#paint0_linear_1_18918)"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="stroke"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1_18918"
        x1="5.47619"
        y1="1"
        x2="5.47619"
        y2="9"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
    </defs>
  </svg>
</template>

<style lang="scss" scoped>
svg .stroke {
  stroke: #df252a;
}
</style>
